import React from 'react';
import classnames from 'classnames';
import { Badge } from 'tea-component';
import ICON_LOCATION from '@gp/assets/svg/location-icon.svg';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface INextMilestoneIconProps extends IBaseProps {
  text?: string;
}

const NextMilestoneIcon: React.FC<INextMilestoneIconProps> = (props) => {
  const { style, className, text = 'Next Milestone' } = props;

  return (
    <div style={style} className={classnames('dbg-milesone-badge', className)}>
      <img className="dbg-milesone-badge-img" width={16} height={16} src={ICON_LOCATION} alt="" />
      <Badge className="dbg-milesone-badge-text">{text}</Badge>
    </div>
  );
};

export default NextMilestoneIcon;
